import type { FixPlansParams } from '../../../../../../shared/types/routes/fixPlans';

import type { IncludeFixPlanFilterOption } from './types';

/**
 * Take the 'includes' options for Fix Plan report and translate them into 'excludes' URL params
 */
export function buildFixPlanParams(
  includeOptions: IncludeFixPlanFilterOption[],
): FixPlansParams {
  const params: FixPlansParams = {};

  // if includeX is not in the list of options, put excludeX into the params
  if (!includeOptions.includes('includeQuickWins')) {
    params.excludeQuickWins = true;
  }

  if (!includeOptions.includes('includeHighPriority')) {
    params.excludeHighPriority = true;
  }

  if (!includeOptions.includes('includeLowPriority')) {
    params.excludeLowPriority = true;
  }

  if (!includeOptions.includes('includeOutdatedDependencies')) {
    params.excludeOutdatedDependencies = true;
  }

  if (includeOptions.includes('includeMalware')) {
    params.includeMalware = true;
  }

  if (includeOptions.includes('includeTransitiveVulns')) {
    params.includeTransitiveVulns = true;
  }

  if (includeOptions.includes('deduplicateOutdatedDeps')) {
    params.deduplicateOutdatedDeps = true;
  }

  return params;
}
